import {Action} from '@ngrx/store';

export const GET_ALL_STORES = '[Stores] Get All';
export const GET_STORE = '[Stores] Get Store';
export const GET_ALL_STORES_SUCCESS = '[Stores] Get All Success';
export const GET_ALL_STORES_ERROR = '[Stores] Get All Error';
export const GET_STORE_SUCCESS = '[Stores] Get Store Success';
export const GET_STORE_ERROR = '[Stores] Get Store Error';

export const ADD_STORE = '[Store] Add';
export const ADD_STORE_SUCCESS = '[Store] Add Success';
export const ADD_STORE_ERROR = '[Store] Add Error';

export const UPDATE_STORE = '[Store] Update';
export const UPDATE_STORE_SUCCESS = '[Store] Update Success';
export const UPDATE_STORE_ERROR = '[Store] Update Error';


export class GetAllStores implements Action {
  readonly type = GET_ALL_STORES;
}

export class GetAllStoresSuccess implements Action {
  readonly type = GET_ALL_STORES_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllStoresError implements Action {
  readonly type = GET_ALL_STORES_ERROR;

  constructor(public payload: any) {
  }
}

export class GetStore implements Action {
  readonly type = GET_STORE;

  constructor(public payload: any) {
  }
}

export class GetStoreSuccess implements Action {
  readonly type = GET_STORE_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetStoreError implements Action {
  readonly type = GET_STORE_ERROR;

  constructor(public payload: any) {
  }
}

export class AddStore implements Action {
  readonly type = ADD_STORE;

  constructor(public payload: any) {
  }
}

export class AddStoreSuccess implements Action {
  readonly type = ADD_STORE_SUCCESS;

  constructor(public payload: any) {
  }
}

export class AddStoreError implements Action {
  readonly type = ADD_STORE_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateStore implements Action {
  readonly type = UPDATE_STORE;

  constructor(public payload: any) {
  }
}

export class UpdateStoreSuccess implements Action {
  readonly type = UPDATE_STORE_SUCCESS;

  constructor(public payload: any) {
  }
}


export class UpdateStoreError implements Action {
  readonly type = UPDATE_STORE_ERROR;

  constructor(public payload: any) {
  }
}


export type StoreAction =
  GetAllStores
  | GetAllStoresSuccess
  | GetAllStoresError
  | GetStore
  | GetStoreError
  | GetStoreSuccess
  | AddStore
  | AddStoreSuccess
  | AddStoreError
  | UpdateStore
  | UpdateStoreSuccess
  | UpdateStoreError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/stores/store/actions/store.actions.ts